import { render } from "./GiftVoucherPaymentMethod.vue?vue&type=template&id=a814bd8a"
import script from "./GiftVoucherPaymentMethod.vue?vue&type=script&lang=js"
export * from "./GiftVoucherPaymentMethod.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__